import { IInvoiceCreate, IInvoiceQueryParams } from '@tsin-core/models/invoice.model';

const ACTION_SCOPE = '[Invoice]';

export class GetInvoices {
  static readonly type = `${ACTION_SCOPE} Get Invoices`;
  constructor(public params?: IInvoiceQueryParams) {}
}

export class GetInvoiceByApplicationId {
  static readonly type = `${ACTION_SCOPE} Get Invoice By Application ID`;
  constructor(public applicationId: string) {}
}

export class GetInvoicesByExamType {
  static readonly type = `${ACTION_SCOPE} Get Invoices By Exam Type`;
  constructor(public examType: string) {}
}

export class GetInvoiceById {
  static readonly type = `${ACTION_SCOPE} Get Invoice By ID`;
  constructor(public invoiceId: string) {}
}

export class GetInvoicesByUserId {
  static readonly type = `${ACTION_SCOPE} Get Invoices By User ID`;
  constructor(public userId: string) {}
}

export class CreateInvoice {
  static readonly type = `${ACTION_SCOPE} Create Invoice`;
  constructor(public payload: IInvoiceCreate) {}
}
